import React from "react";
import "./stylesheet.css";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import { Container, Box, Grid, Typography } from '@mui/material';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MainImage from "../forget/global_wings.png";
import { postApi } from "../../../services/axiosInstance";
import { API_PATH } from "../../../services/apipath";
import { useForm } from "react-hook-form";


const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const defaultTheme = createTheme();
  const onSubmit = async (data) => {
    try {
      const res = await postApi(API_PATH.SUPER_ADMIN.LOGIN, data);
      if (res.status === 200) {
        localStorage.setItem("token", res.data.token);
        window.location.replace("/home");
      }
    } catch (error) {
      // console.log(error, "login error");
    }
  };

  return (
    <>
      <Container maxWidth={false} disableGutters>
        <Grid container sx={{ paddingX: "50px", backgroundColor: "#1F2A40" }}>
          <Grid item xs={12} md={12} >
            <ThemeProvider theme={defaultTheme}>
              <Grid
                container
                component="main"
                sx={{
                  height: "100vh",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CssBaseline />

                <Grid item xs={12}>
                  <Box
                    sx={{
                      mt: 5,
                      marginX: { sm: 0, lg: 4 },
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "90vh",
                    }}
                  >
                    <Box
                      component="img"
                      src={MainImage}
                      alt="MainlogoPTE"
                      sx={{ width: "30%" }}
                    />
                    <Typography component="h1" variant="h5" sx={{ color: "white" }}>
                      Login
                    </Typography>

                    <Box
                      component="form"
                      noValidate
                      onSubmit={handleSubmit(onSubmit)}
                      sx={{
                        mt: 1,
                        width: {
                          xs: '100%',
                          sm: '60%',
                        }
                      }}
                    >

                      <div className="form-group">
                        <label htmlFor="email" className="mb-1 text-white">Email Address</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Enter your email"
                          required
                          fullWidth
                          label="Email Address"
                          name="email"
                          autoComplete="email"
                          autoFocus
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9._%+-]+@(gmail|yahoo|mail)\.com$/i,
                              message: "Please enter a valid  email address",
                            },
                          })}
                          error={!!errors.email}
                          helperText={errors.email?.message}
                          FormHelperTextProps={{ style: { margin: 0 } }}
                        />
                      </div>


                      <div className="form-group mt-2">
                        <label htmlFor="password" className="mb-1 text-white">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          placeholder="Enter your password"
                          required
                          fullWidth
                          name="password"
                          label="Password"
                          autoComplete="current-password"
                          {...register("password", {
                            required: "Password is required",
                          })}
                          error={!!errors.password}
                          helperText={errors.password?.message}
                          FormHelperTextProps={{ style: { margin: 0 } }}
                        />
                      </div>

                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, backgroundColor: "#F8CC40" }}
                      >
                        Login
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </ThemeProvider>
          </Grid>

        </Grid>
      </Container>
    </>
  );
};

export default Login;
